export default function SelectOption({ label, required, name, values, handler }) {
    return (
        <div className="form-group">
            <label className='text-uppercase'>
                {label} {required && <strong className="text-danger">*</strong>}
            </label>
            <select
                className="form-control required"
                name={name}
                onChange={handler}
            >
                {
                    values.map(({ value, name }, key) => (
                        <option value={value} key={key}>{name}</option>
                    ))
                }
            </select>
        </div>
    )
}
